import { getOauthUrl } from "helpers/Auth";
import { useAuth } from "hooks/Auth";
import React, { useEffect, useState, useRef } from "react";
import { Route, useLocation } from "react-router";
import PublicationChooserScreen from "Screens/PublicationChooserScreen";
import LoaderShell from "./LoaderShell";

function ProtectedRoute({ children, requiresAdmin, ...props }) {
    const [isAuthenticated, setIsAuthenticated] = useState(false);
    const [hasPublication, setHasPublication] = useState(false);
    const [showPublicationChooser, setShowPublicationChooser] = useState(false);
    const authRef = useRef(false);

    const auth = useAuth();
    const location = useLocation();

    useEffect(() => {
        console.log("Validate Publication");
        if (!isAuthenticated) {
            return;
        }
        if (!auth.publication) {
            setShowPublicationChooser(true);
            return;
        }

        setHasPublication(true);

        return () => {
            setShowPublicationChooser(false);
            setHasPublication(false);
            setIsAuthenticated(false);
        };
    }, [isAuthenticated, auth.publication]);

    useEffect(() => {
        // Runs once, on load so it's incumbent on the app to check
        // group and access status
        // using bearer token for related queries
        if (authRef.current === false) {
            authRef.current = true;
            auth.verifyAuth().then((didAuthenticate) => {
                console.info("Validate protected route");
                if (!didAuthenticate) {
                    window.location.href = getOauthUrl(location.pathname);
                    return;
                }
                setIsAuthenticated(true);
            });
        }
        return () => {
            setIsAuthenticated(false);
            authRef.current = false;
        };
        // TODO not sure how to memoize this without causing auth issues or re-rendering
        // eslint-disable-next-line
    }, []);

    if (isAuthenticated && showPublicationChooser) {
        return <PublicationChooserScreen />;
    }

    return (
        <Route
            {...props}
            render={() =>
                isAuthenticated && hasPublication ? children : <LoaderShell />
            }
        />
    );
}

export default ProtectedRoute;
